<template>
  <div class="onboarding-use-cases-step">
    <h1 class="onboarding-use-cases-step__message">
      {{ $t('components.Onboarding.label.title.useCaseMessage') }}
    </h1>

    <p class="onboarding-use-cases-step__case-message">
      {{ $t('components.Onboarding.label.title.mustChooseUseCaseMessage') }}
    </p>
    <div
      class="onboarding-use-cases-step__case-chips"
    >
      <div
        v-for="item in useCasesList"
        :key="item.text"
        class="onboarding-use-cases-step__chips"
      >
        <DsChip
          v-if="isAddable(item.type)"
          icon
          name="add-circle"
          :type="item.type"
          :title="item.text"
          @click="toggleChips(item.text)"
        />
        <DsChip
          v-else
          icon
          name="close-circle"
          :type="item.type"
          :title="item.text"
          @click="toggleChips(item.text)"
        />
      </div>
    </div>
    <div>
      <h2 class="onboarding-use-cases-step__others-message">
        {{ $t('components.Onboarding.label.title.others') }}
      </h2>
      <p
        class="onboarding-use-cases-step__case-message"
      >
        {{ $t('components.Onboarding.label.title.notFoundUseCaseMessage') }}
      </p>
      <v-combobox
        v-model="onboardingData.otherUseCases"
        class="onboarding-use-cases-step__other-case-field"
        outlined
        :items="[]"
        placeholder="Escreva aqui"
        :rules="isNotEmptyRule"
        multiple
        small-chips
        deletable-chips
        append-icon=""
        dense
        @change="callValidation()"
      >
        <template v-slot:selection="{ index, item }">
          <OnboardingChips
            icon
            type="removable"
            name="close-circle"
            class="mr-2 my-1"
            :title="item"
            @click="removeOtherUseCases(index)"
          />
        </template>
      </v-combobox>
    </div>
  </div>
</template>

<script>
import { DsChip } from '@ds/components';
import OnboardingChips from './../OnboardingChips.vue';
import { USE_CASE_LIST } from '@/utils/constants';

const ADDABLE = 'addable';
const REMOVABLE = 'removable';

export default {
  name: 'OnboardingUseCasesStep',
  components: {
    DsChip,
    OnboardingChips,
  },
  props: {
    onboardingData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      useCasesList: USE_CASE_LIST,
      isNotEmptyRule: [() => {
        return Boolean(this.onboardingData.otherUseCases.length || this.onboardingData.useCases.length);
      }],
    };
  },
  beforeMount() {
    this.useCasesList.forEach(useCase => {
      if (!this.isAddable(useCase.type)) {
        useCase.type = ADDABLE;
      }
    });
  },
  methods: {
    toggleChips(text) {
      this.useCasesList.forEach(input => {
        if (text === input.text && this.isAddable(input.type)) {
          input.type = REMOVABLE;
          this.addUseCase(text);
        } else if (text === input.text && !this.isAddable(input.type)) {
          input.type = ADDABLE;
          this.removeUseCase(text);
        }
      });
      this.callValidation();
    },
    isAddable(type) {
      return Boolean(type === ADDABLE);
    },
    addUseCase(itemText) {
      this.onboardingData.useCases.push(itemText);
    },
    removeUseCase(text) {
      this.onboardingData.useCases = this.onboardingData.useCases.filter((value) => {
        return value !== text;
      });
    },
    removeOtherUseCases(index) {
      this.onboardingData.otherUseCases.splice(index, 1);
    },
    callValidation() {
      this.$parent.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
  $st-message-color: #000;
  $st-default-border-color: rgba(0, 0, 0, 0.38);

  .onboarding-use-cases-step {
    &__message {
      color: $st-message-color;
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      line-height: var(--ds-font-line-height-normal);
    }

    &__case-message {
      color: var(--ds-color-text-2);
      margin-top: var(--ds-spacing-inline-nano);
      margin-bottom: var(--ds-spacing-inline-sm);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
    }

    &__case-chips {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: var(--ds-spacing-inline-md);
      width: 800px;
    }

    &__chips {
      display: inline;
      margin-right: var(--ds-spacing-inline-nano);
      margin-bottom: var(--ds-spacing-inline-nano);
    }

    &__others-message {
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-lg);
      line-height: var(--ds-font-line-height-dense);
    }

    &__other-case-field {
      width: 489px;
    }
  }

  ::v-deep {
    .v-text-field--outlined.v-input--is-focused fieldset {
      border: 2px solid var(--ds-color-primary) !important;
    }

    .v-text-field--outlined.v-input--has-state fieldset {
      border: 1px solid $st-default-border-color !important;
    }
  }

</style>
